import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Icon } from '../Icon';
import useIconButtonStyles from '../IconButton/useIconButtonStyles';
const defaultProps = {
    onBlur: () => { },
    onClick: () => { },
    onFocus: () => { },
    onKeyDown: () => { },
    onKeyUp: () => { },
    onMouseDown: () => { },
    onMouseLeave: () => { },
    onMouseUp: () => { },
    onTouchEnd: () => { },
    onTouchMove: () => { },
    onTouchStart: () => { },
};
const FavoriteButton = ({ disabled, isFavorite, label, onBlur = defaultProps.onBlur, onClick = defaultProps.onClick, onFocus = defaultProps.onFocus, onKeyDown = defaultProps.onKeyDown, onKeyUp = defaultProps.onKeyUp, onMouseDown = defaultProps.onMouseDown, onMouseLeave = defaultProps.onMouseLeave, onMouseUp = defaultProps.onMouseUp, onTouchEnd = defaultProps.onTouchEnd, onTouchMove = defaultProps.onTouchMove, onTouchStart = defaultProps.onTouchStart, }) => {
    const iconType = useMemo(() => (isFavorite
        ? 'favorited'
        : 'favorite'), [
        isFavorite,
    ]);
    const buttonColor = useMemo(() => (isFavorite
        ? theme.colors.accent600
        : theme.colors.gray700), [
        isFavorite,
    ]);
    const buttonStyles = useIconButtonStyles({
        modifier: 'custom',
        size: 'medium',
        styleVariation: {
            backgroundColor: theme.colors.gray100,
            boxShadow: `0 0 ${styleUtils.rem(11)} rgba(0, 0, 0, 0.15)`,
            color: buttonColor,
            disabledBackgroundColor: undefined,
            disabledColor: theme.colors.gray700,
            hoverBackgroundColor: undefined,
            hoverTextColor: buttonColor,
        },
    });
    return (_jsx("button", Object.assign({ "aria-label": label, css: buttonStyles, disabled: disabled, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, type: "button" }, { children: _jsx(Icon, { size: "extraSmall", type: iconType }) })));
};
const MemoizedFavoriteButton = memo(FavoriteButton);
export { MemoizedFavoriteButton as FavoriteButton };
